import { exerciseGoalListOutput, exerciseGoalPath, exerciseGoalView, exerciseNoteListOutput, exerciseNotePath, exerciseNoteView, exercisePreferenceListOutput, exercisePreferencePath, exercisePreferenceView, strengthLevelOutput, strengthLevelPath, strengthLevelsOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { getJson, sendJson, sendNoContent, withQuery, } from "../core";
/**
 * The route functions of the person's own exercise data (`D200`, `D208`).
 * The writes are plain functions as well as mutations, so the outbox replays
 * them (`D194`) — every one answers a resend the way it answered the send.
 */
/** `GET /me/exercise-notes` — every note. */
export function fetchExerciseNotes(api, init) {
    return getJson(api, TRAINING_ROUTES.exerciseNotes, exerciseNoteListOutput, init);
}
/** `PUT /me/exercise-notes/:exerciseId` — replaces; last write wins. */
export function putExerciseNote(api, exerciseId, input) {
    return sendJson(api, "PUT", exerciseNotePath(exerciseId), input, exerciseNoteView);
}
/** `DELETE /me/exercise-notes/:exerciseId` — 204 whether or not it was there. */
export function removeExerciseNote(api, exerciseId) {
    return sendNoContent(api, "DELETE", exerciseNotePath(exerciseId));
}
/** `GET /me/exercise-preferences` — every favourite and preference. */
export function fetchExercisePreferences(api, init) {
    return getJson(api, TRAINING_ROUTES.exercisePreferences, exercisePreferenceListOutput, init);
}
/** `PUT /me/exercise-preferences/:exerciseId` — a key left out is kept. */
export function putExercisePreference(api, exerciseId, input) {
    return sendJson(api, "PUT", exercisePreferencePath(exerciseId), input, exercisePreferenceView);
}
/** `GET /me/exercise-goals?exerciseId&locale` — the live goals. */
export function fetchExerciseGoals(api, options = {}, init) {
    return getJson(api, withQuery(TRAINING_ROUTES.exerciseGoals, {
        exerciseId: options.exerciseId,
        locale: options.locale,
    }), exerciseGoalListOutput, init);
}
/** `POST /me/exercise-goals` — under the client's id: 201, or 200 on a resend. */
export function createExerciseGoal(api, input) {
    return sendJson(api, "POST", TRAINING_ROUTES.exerciseGoals, input, exerciseGoalView);
}
/** `DELETE /me/exercise-goals/:id` — 204, again on a resend. */
export function removeExerciseGoal(api, goalId) {
    return sendNoContent(api, "DELETE", exerciseGoalPath(goalId));
}
/** `GET /me/strength-levels?locale` — every logged lift with a standard. */
export function fetchStrengthLevels(api, options = {}, init) {
    return getJson(api, withQuery(TRAINING_ROUTES.strengthLevels, { locale: options.locale }), strengthLevelsOutput, init);
}
/** `GET /me/strength-levels/:exerciseId` — one lift, logged or not. */
export function fetchStrengthLevel(api, exerciseId, init) {
    return getJson(api, strengthLevelPath(exerciseId), strengthLevelOutput, init);
}
//# sourceMappingURL=api.js.map